import { connectStepper } from "../util/redux";
import Word from "../components/word";

export default connectStepper(Word);
